import { set } from 'lodash-es'

export default async (_, locale) => {
  let translations

  switch (locale) {
    case 'de':
    default:
      translations = await import(`@/content/translations/de.json`)
      break
  }

  return translations.default.translation_items.reduce((acc, { key, value }) => {
    return set(acc, key, value)
  }, {})
}
